import { render, staticRenderFns } from "./StepCompany.vue?vue&type=template&id=155aff43"
import script from "./StepCompany.vue?vue&type=script&lang=ts"
export * from "./StepCompany.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports